import React, {useState} from 'react'
import {Button, Form, Header, List, Message, Modal} from 'semantic-ui-react'
import _ from 'lodash'

const RemovalConfirmationModal = (
  {
    propName = 'n/a',
    confirmingRemovalOf = 'n/a',
    expectedPropValue = '',
    removalButtonText = 'Remove',
    headerContent,
    onRemovalApproved,
    onRemovalCancelled
  }
) => {
  const [form, setForm] = useState({actualPropValue: '', submitted: false, submitting: false, errors: {}})

  const validate = ({actualPropValue, errors = {}}) => {
    if (!!expectedPropValue && !actualPropValue) {
      errors['removal.actual.required'] = 'Name required'
    } else {
      delete errors['removal.actual.required']
      if (actualPropValue !== expectedPropValue) {
        errors['removal.actual.mismatch'] = `Provided text: '${actualPropValue}' does not match expected text: '${expectedPropValue}'`
      } else {
        delete errors['removal.actual.mismatch']
      }
    }
    return errors
  }

  const onInputChange = (e) => {
    let updatedForm = {...form, ...{[e.target.name]: e.target.value}}
    let errors = {}
    if (form.submitted) {
      errors = validate(updatedForm)
      updatedForm = {...updatedForm, ...{errors}}
    }
    setForm(updatedForm)
  }

  const close = (e) => {
    if (e) {
      e.preventDefault()
    }
    onRemovalCancelled()
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const errors = validate(form)
    if (_.keys(errors).length) {
      setForm({...form, ...{submitted: true, errors}})
      return
    }
    setForm({...form, ...{submitting: true}})
    const serviceErrors = await onRemovalApproved()
    if (serviceErrors) {
      setForm({...form, ...{errors: {...errors, ...serviceErrors}}})
    }
  }

  let {
    actualPropValue,
    errors,
    submitting
  } = form

  const hasErrors = Object.keys(errors).some((k) => k.indexOf('removal.actual') > -1)
  if (!headerContent) {
    headerContent = `Confirm removal of ${confirmingRemovalOf}`
    if (expectedPropValue) {
      headerContent += ` with ${propName}: ${expectedPropValue}`
    }
  }
  return (
    <div>
      <Modal open={true} closeOnDimmerClick={true} closeIcon={true} onClose={close}
             data-testid='removal-confirmation-modal'>
        <Header content={headerContent}/>
        <Modal.Content>
          {
            !!expectedPropValue && (<Form error={hasErrors} onSubmit={onSubmit}>
              <Form.Field error={hasErrors} required>
                <label>Name</label>
                <Form.Input placeholder={`Type ${confirmingRemovalOf} ${propName} and click 'Remove'`}
                            name='actualPropValue'
                            value={actualPropValue}
                            data-testid='removal-confirmation-textbox'
                            onChange={onInputChange}/>
              </Form.Field>
              <Message error data-testid='removal-confirmation-errors'>
                <Message.Content>
                  <List bulleted>
                    {
                      Object.keys(errors).map((key) => (
                        <List.Item key={key}>{errors[key]}</List.Item>
                      ))
                    }
                  </List>
                </Message.Content>
              </Message>
            </Form>)
          }
          {
            !expectedPropValue && (<p>Are you sure you want to continue?</p>)
          }
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={close} data-testid='removal-confirmation-cancel-button'>Cancel</Button>
          <Button primary onClick={onSubmit} loading={submitting}
                  data-testid='removal-confirmation-submit-button'>{removalButtonText}</Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}


export {RemovalConfirmationModal}

export default RemovalConfirmationModal